<template>
  <div class="data-driven" style="background-color: white">
    <div class="condition-controller">
      <div style="margin:4px; color: red">Conditions Controller</div>
      <div class="each-condition">
        <div class="each-condition--name">
          time
        </div>
        <el-time-picker
          v-model="conditionsController.time"
          placeholder="choose your time"
          class="each-condition--tool"
        >
        </el-time-picker>
      </div>
      <div class="each-condition">
        <div class="each-condition--name">
          weather
        </div>
        <el-select
          v-model="conditionsController.weather"
          placeholder="choose weather"
          class="each-condition--tool"
        >
          <el-option
            v-for="value in weatherOption"
            :key="value"
            :label="value"
            :value="value"
          >
          </el-option>
        </el-select>
      </div>
      <div class="each-condition">
        <div class="each-condition--name">
          humidity (%)
        </div>
        <div class="each-condition--tool">
          <el-slider
            style="width: 150px; margin-left: 12px;"
            v-model="conditionsController.humidity"
            :disabled="isDemo"
          ></el-slider>
          <div style="margin-left: 12px;">
            {{ conditionsController.humidity }}
          </div>
        </div>
      </div>
      <div class="each-condition">
        <div class="each-condition--name">
          temperature (°C)
        </div>
        <div class="each-condition--tool">
          <el-slider
            style="width: 150px; margin-left: 12px;"
            v-model="conditionsController.temperature"
            :disabled="isDemo"
          ></el-slider>
          <div style="margin-left: 12px;">
            {{ conditionsController.temperature }}
          </div>
        </div>
      </div>
      <div class="each-condition">
        <div class="each-condition--name">
          pm2.5 (μg/m3)
        </div>
        <div class="each-condition--tool">
          <el-slider
            style="width: 150px; margin-left: 12px;"
            v-model="conditionsController.pm25"
            :disabled="isDemo"
          ></el-slider>
          <div style="margin-left: 12px;">
            {{ conditionsController.pm25 }}
          </div>
        </div>
      </div>
    </div>
    <img :src="isamnet" style="width: 100%" />
    <div class="main-wrapper">
      <a
        class="closebutton"
        @click="close()"
        v-if="creative.preview_type === CONSTANT.ENUM_PREVIEW_TYPE.INTERSTITIAL"
      >
      </a>
      <div
        id="main-container"
        :style="`width: ${creative.width}px; height:${creative.height}px;`"
      >
        <div class="weather" :style="weatherStyle">
          <div class="weather-box" :style="weatherBoxStyle">
            <div
              class="weather-box__item"
              v-if="firstValidateDataWithCondition.time_duration_display"
            >
              <div class="demo-icon icon-clock weather-box__item--label"></div>
              <div class="weather-box__item--value">
                {{ controllerFormatTime }}
              </div>
            </div>
            <div
              class="weather-box__item"
              v-if="firstValidateDataWithCondition.weather_display"
            >
              <div
                v-if="conditionsController.weather === 'Sunny'"
                class="demo-icon icon-sun weather-box__item--label"
              ></div>
              <div
                v-if="conditionsController.weather === 'Rainy'"
                class="demo-icon icon-rain weather-box__item--label"
              ></div>
              <div
                v-if="conditionsController.weather === 'Cloudy'"
                class="demo-icon icon-cloud weather-box__item--label"
              ></div>
              <div class="weather-box__item--value">
                {{ conditionsController.weather }}
              </div>
            </div>
            <div
              class="weather-box__item"
              v-if="firstValidateDataWithCondition.humidity_display"
            >
              <div class="demo-icon icon-water weather-box__item--label"></div>
              <div class="weather-box__item--value">
                {{ conditionsController.humidity }} %
              </div>
            </div>
            <div
              class="weather-box__item"
              v-if="firstValidateDataWithCondition.temperature_display"
            >
              <div
                class="demo-icon icon-temperatire weather-box__item--label"
              ></div>
              <div class="weather-box__item--value">
                {{ conditionsController.temperature }} °C
              </div>
            </div>
            <div
              class="weather-box__item"
              v-if="firstValidateDataWithCondition.pm25_display"
            >
              <div style="display: flex;" class="weather-box__item--label">
                <div
                  style="font-size: 14px; align-items: flex-end; display: flex"
                >
                  PM
                </div>
                <div
                  style="font-size: 8px; align-items: flex-end; display: flex"
                >
                  2.5
                </div>
              </div>
              <div class="weather-box__item--value">
                {{ conditionsController.pm25 }}
              </div>
            </div>
          </div>
        </div>
        <a
          v-if="creative.material_type === CONSTANT.MATERIAL_TYPE.IMAGES"
          :href="firstValidateDataWithCondition.landing_page"
          target="_blank"
          class="image"
        >
          <img :src="firstValidateDataWithCondition.image_url" />
        </a>
        <div
          v-if="creative.material_type === CONSTANT.MATERIAL_TYPE.HTML"
          :style="
            `width: ${creative.width}px; height: ${
              creative.height
            }px; position:absolute; z-index:10;`
          "
          @click="openLandingPage"
        ></div>
        <iframe
          v-if="creative.material_type === CONSTANT.MATERIAL_TYPE.HTML"
          :src="firstValidateDataWithCondition.html_url"
          scrolling="no"
          frameborder="0"
          allowfullscreen="true"
          :style="
            `border: none !important; overflow: hidden !important; display: block; background-color: black !important; width: ${
              creative.width
            }px !important; height: ${creative.height}px !important;`
          "
        />
      </div>
    </div>
    <img
      :src="
        setBgImg(
          'https://cdn.aralego.net/rich_media/assets/banner/bg2.png',
          creative.preview_device
        )
      "
      style="width: 100%"
    />
    <img
      :src="
        setBgImg(
          'https://cdn.aralego.net/rich_media/assets/banner/bg3.png',
          creative.preview_device
        )
      "
      style="width: 100%"
    />
  </div>
</template>
<script>
import mixPreview from "@/components/mixins/preview.js";
import mixOutstream from "@/components/mixins/outstream.js";
import mixMobile from "@/components/mixins/mobile.js";
export default {
  data() {
    return {
      conditionsController: {
        time: new Date(),
        weather: "",
        humidity: 0,
        temperature: 0,
        pm25: 0,
      },
    };
  },
  computed: {
    isDemo() {
      return this.$route.params.creativeId === "demo";
    },
    weatherStyle() {
      let { justify, align } = this.dataPosition;
      let styleObj = {
        display: "flex",
        justifyContent: justify.position,
        alignItems: align.position,
        width: `${this.creative.width}px`,
        height: `${this.creative.height}px`,
        position: "absolute",
      };
      return styleObj;
    },
    weatherBoxStyle() {
      let { justify, align } = this.dataPosition;
      let styleObj = {};
      if (justify.position !== "center") {
        styleObj[justify.paddingDirection] = `${justify.paddingPx}px`;
      }
      if (align.position !== "center") {
        styleObj[align.paddingDirection] = `${align.paddingPx}px`;
      }
      return styleObj;
    },
    dataPosition() {
      let vertical_align = this.firstValidateDataWithCondition.vertical_align;
      let vertical_padding = this.firstValidateDataWithCondition
        .vertical_padding;
      let horizontal_align = this.firstValidateDataWithCondition
        .horizontal_align;
      let horizontal_padding = this.firstValidateDataWithCondition
        .horizontal_padding;

      let justify = {
        position: "center",
        paddingDirection: "",
      };
      let align = {
        position: "center",
        paddingDirection: "",
      };

      if (vertical_align === "top") {
        align.position = "flex-start";
        align.paddingDirection = "marginTop";
        align.paddingPx = vertical_padding;
      } else if (vertical_align === "bottom") {
        align.position = "flex-end";
        align.paddingDirection = "marginBottom";
        align.paddingPx = vertical_padding;
      }
      if (horizontal_align === "left") {
        justify.position = "flex-start";
        justify.paddingDirection = "marginLeft";
        justify.paddingPx = horizontal_padding;
      } else if (horizontal_align === "right") {
        justify.position = "flex-end";
        justify.paddingDirection = "marginRight";
        justify.paddingPx = horizontal_padding;
      }
      return { justify, align };
    },
    isamnet() {
      let domain = window.location.hostname;
      let isAmnet = "https://cdn.aralego.net/rich_media/assets";
      if (domain === "prism.amnet.tw") {
        isAmnet += "/amnet/bg2.png";
      } else {
        isAmnet += "/banner/bg1.png";
      }
      this.setBgImg(isAmnet, this.creative.preview_device);
      return isAmnet;
    },
    weatherControllerStyle() {
      let obj = {
        width: "300px",
        height: "300px",
        position: "fixed",
        border: "5px solid DarkBlue",
        backgroundColor: "LightBlue",
        top: "10px",
        left: "10px",
      };
      return obj;
    },
    weatherOption() {
      return ["Rainy", "Cloudy", "Sunny"];
    },
    firstValidateDataWithCondition() {
      let conditions = this.creative.conditions;
      let defaultCondition = conditions[0]; // default
      let mapConditions = conditions.filter((element, index) => {
        if (index === 0) {
          return false;
        }

        let maxTime = 86400;
        let minTime = 0;
        if (element.time_duration) {
          maxTime = this.getUnitTimeWithHourMinSec(element.time_duration[1]);
          minTime = this.getUnitTimeWithHourMinSec(element.time_duration[0]);
        }
        if (!this.controllerUnitTimeWithHourMinSec) {
          return false;
        } else if (
          element.time_duration &&
          ((element.time_duration.length === 2 &&
            this.controllerUnitTimeWithHourMinSec > maxTime) ||
            this.controllerUnitTimeWithHourMinSec < minTime)
        ) {
          return false;
        } else if (
          element.weather &&
          element.weather !== this.conditionsController.weather
        ) {
          return false;
        } else if (
          (element.humidity_max !== null &&
            element.humidity_min !== null &&
            this.conditionsController.humidity > element.humidity_max) ||
          this.conditionsController.humidity < element.humidity_min
        ) {
          return false;
        } else if (
          (element.temperature_unit === CONSTANT.TEMPERATURE_TYPE.C &&
            element.temperature_max !== null &&
            element.temperature_min !== null &&
            this.conditionsController.temperature > element.temperature_max) ||
          this.conditionsController.temperature < element.temperature_min
        ) {
          return false;
        } else if (
          (element.temperature_unit === CONSTANT.TEMPERATURE_TYPE.F &&
            element.temperature_max !== null &&
            element.temperature_min !== null &&
            (this.conditionsController.temperature * 9) / 5 + 32 >
              element.temperature_max) ||
          (this.conditionsController.temperature * 9) / 5 + 32 <
            element.temperature_min
        ) {
          return false;
        } else if (
          (element.pm25_max !== null &&
            element.pm25_min !== null &&
            this.conditionsController.pm25 > element.pm25_max) ||
          this.conditionsController.pm25 < element.pm25_min
        ) {
          return false;
        } else {
          return true;
        }
      });
      if (mapConditions.length > 0) {
        return mapConditions[0];
      } else {
        return defaultCondition;
      }
    },
    controllerUnitTimeWithHourMinSec() {
      if (this.conditionsController.time) {
        let time = new Date(this.conditionsController.time);
        let hour = time.getHours();
        let min = time.getMinutes();
        let sec = time.getSeconds();
        return hour * 3600 + min * 60 + sec;
      } else {
        return null;
      }
    },
    controllerFormatTime() {
      let time = new Date(this.conditionsController.time);
      let hour = time.getHours();
      let min = time.getMinutes();
      let sec = time.getSeconds();
      let hourDisplay = hour < 10 ? "0" + hour : hour;
      let minDisplay = min < 10 ? "0" + min : min;
      let secDisplay = sec < 10 ? "0" + sec : sec;
      return `${hourDisplay}:${minDisplay}:${secDisplay}`;
    },
  },
  mixins: [mixPreview, mixMobile, mixOutstream],
  async mounted() {
    this.viewport();
    await this.$nextTick();
    const banner = document.querySelector("#main-container");
    const wrapper = document.querySelector(".main-wrapper");
    if (this.creative.preview_type === CONSTANT.ENUM_PREVIEW_TYPE.CONTENT) {
      wrapper.nextElementSibling.after(wrapper);
    } else if (
      this.creative.preview_type === CONSTANT.ENUM_PREVIEW_TYPE.INTERSTITIAL
    ) {
      wrapper.classList.add("mask");
      wrapper.onclick = (e) => {
        if (e.target === wrapper) this.close();
      };
      this.setStyle(banner, {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
      });
    }
  },
  methods: {
    openLandingPage() {
      window.open(this.firstValidateDataWithCondition.landing_page, "_blank");
    },
    getUnitTimeWithHourMinSec(date) {
      let time = new Date(date);
      let hour = time.getHours();
      let min = time.getMinutes();
      let sec = time.getSeconds();
      return hour * 3600 + min * 60 + sec;
    },
  },
};
</script>
<style lang="sass" scoped>
#main-container
  cursor: pointer
  margin: auto
  position: relative
  overflow: hidden

.image
  position: absolute
  top: 0
  left: 0

.mask
  display: block
  position: fixed
  top: 0px
  left: 0px
  width: 100%
  height: 100%
  z-index: 2147483647
  background-image: url(https://s.yimg.com/ja/ap/tw/bwchou/fullpage_bg.png)
  .closebutton
    cursor: pointer
    position: absolute
    display: block
    width: 32px
    height: 32px
    background-color: white
    background-position: 0 0
    background-image: url('https://cdn.aralego.net/rich_media/assets/close_btn.png')
    z-index: 50000
    top: 5px
    right: 5px
    background-size: contain
    border-radius: 16px
.weather-box
  width: 100px
  z-index: 999

  &__item
    display: flex
    &--label
      color: white
    &--value
      margin-left: 4px
      color: white
.condition-controller
  padding: 4px 0px
  width: 300px
  height: 320px
  position: fixed
  border: 5px solid DarkBlue
  background-color: LightBlue
  top: 30%
  left: 10px
  z-index: 100
  .each-condition
    display: flex
    align-items: center
    margin-top: 12px
    &--name
      margin: 4px
      width: 85px
    &--tool
      width: 190px
      display: flex
      justify-content: space-around
      align-items: center
</style>
